// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__8LicP","button":"style_button__ETdbo","buttonBold":"style_buttonBold__4dIxP","buttonRegular":"style_buttonRegular__C+pTu"};